module.exports = __webpack_public_path__ + "static/media/shape2_5.3b9514b4.obj";